import {BitmapWinCountUp} from "@nolimitcity/slot-game/bin/game/winpresentation/countup/BitmapWinCountUp";
import {Elastic, Linear, Timeline, TimelineLite, TweenLite} from "gsap";

/**
 * Created by h3 on 2018-09-24.
 */


export class CountUpBit extends BitmapWinCountUp {

    constructor() {
        super({
            font : {
                name : "WinNumbersBM",
                size : 38
            }
        });
    }

    public getCountUpAnimation(from:number, to:number, duration:number):TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add([
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            },
            this._countUp.getCountUpAnimation(from, to, {
                duration : duration,
                ease : Linear.easeNone
            }),
            TweenLite.fromTo(this._countUpContainer.scale, 1,
                {x : 0.5, y : 0.5},
                {
                    x : 1,
                    y : 1,
                    ease : Elastic.easeOut.config(2, 1)
                })
        ]);

        return tl;
    }

    protected getAbortAnimation(endValue:number, multiplier:number):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            TweenLite.fromTo(this._countUpContainer.scale, 0.2,
                {x : 0.5, y : 0.5},
                {
                    x : 1,
                    y : 1,
                    ease : Elastic.easeOut.config(2, 1)
                }),
            this._countUp.getCountUpAnimation(endValue, endValue, {duration : 0.01})
        ]);
        return timeline;
    }

    public getEndingAnimation():TimelineLite {
        const tl:TimelineLite = new TimelineLite();
        tl.add(TweenLite.to(this._countUp, 0.2, {alpha : 0}), `+=0.8`);

        return tl;
    }

    public setMaxWidth(value:number):void {
        if (this._countUp) {
            this._countUp.maxTextWidth = value;

        }
    }
}